<template>
  <!-- Page Introduction Wrapper -->
  <div class="page-style-a">
    <div class="container">
      <div class="page-intro">
        <h2>Profile</h2>
        <ul class="bread-crumb">
          <li class="has-separator">
            <i class="ion ion-md-home"></i>
            <a href="/">Home</a>
          </li>
          <li class="is-marked">
            <a href="account.html">Reset Password</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- Page Introduction Wrapper /- -->
  <div class="page-account u-s-p-t-80">
    <div class="row justify-content-center">
      <form action="" class="col-lg-5" @submit.prevent="handleChangePassword">
        <div class="">
          <label for="user-name-email">Email </label>
          <input
            type="email"
            id="email"
            class="text-field"
            placeholder="Email Address"
            readonly
            v-model="email"
          />
        </div>
        <div class="mt-3">
          <label for="user-name-email">New Password </label>
          <input
            type="password"
            id="password"
            class="text-field"
            placeholder="New Password"
            required
            v-model="password"
            minlength="8"
          />
        </div>
        <div class="mt-3">
          <label for="user-name-email">Confirm Password </label>
          <input
            type="password"
            id="confirm_password"
            class="text-field"
            placeholder="Confirm Password"
            required
            v-model="confirm_password"
            minlength="8"
          />
        </div>
        <div class="mt-3">
          <button :disabled="loading" class="button button-primary w-100">{{loading ? 'Please Wait.' : 'Change Password'}}</button>
        </div>
      </form>
    </div>
  </div>
  <Footer />
</template>

<script>
import axios from "axios";
import Footer from "../components/Bottom/Footer.vue";
import Spinner from "../components/Loaders/Spinner.vue";
import Popper from "vue3-popper";
import { useToast } from 'vue-toastification';
export default {
  components: { Footer, Spinner, Popper },
  data() {
    return {
      email: this.$route.query.email,
      password: "",
      confirm_password: "",
      token: this.$route.params.token,
      error: "",
      loading: false,
    };
  },
  methods: {
    async handleChangePassword() {
      this.loading = true;
      let url = process.env.VUE_APP_API_URL + "/api/reset-password";
      let postData = {
        email: this.email,
        token: this.token,
        password: this.password,
        password_confirmation: this.confirm_password,
      };
      try {
        // send post request
        let { data } = await axios.post(url, postData);
        this.loading = false;
        this.$router.push("/account");
        useToast().success('Password Changed Successfully.', {timeout : 3000})
      } catch (error) {
        console.log(error.response.data);
        this.loading = false;
        useToast().error(error.response.data.message, {timeout : 3000})
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
</style>
